import {Parameter} from 'platform/components';
import {useDateTimeFormatter} from 'platform/locale';

import {isNotNil} from 'ramda';

import {useGetUserQuery} from '@dms/api/customer';
import i18n from '@dms/i18n';

import {Nullish, buildArray, parseDate} from 'shared/web';

import {EMPTY_PLACEHOLDER} from '../../../constants/placeholders';
import {getUserName} from '../../../utils/getUserName';
import {PostponeJobType} from '../types/PostponeJobType';

export function useSummaryParams(postponeJobData: PostponeJobType | Nullish) {
  const formatDateTime = useDateTimeFormatter();

  const userQuery = useGetUserQuery(
    {id: postponeJobData?.postponedBy || ''},
    {skip: !postponeJobData?.postponedBy}
  );

  return buildArray<Parameter>()
    .when(postponeJobData?.postponedAt, () =>
      i18n.t('entity.postponedJobs.label.postponedAt', {
        date: isNotNil(postponeJobData?.postponedAt)
          ? formatDateTime('dateShort', parseDate(postponeJobData?.postponedAt))
          : EMPTY_PLACEHOLDER,
      })
    )
    .when(postponeJobData?.postponedUntil, () =>
      i18n.t('entity.postponedJobs.label.postponedUntil', {
        date: isNotNil(postponeJobData?.postponedUntil)
          ? formatDateTime('dateShort', parseDate(postponeJobData?.postponedUntil))
          : EMPTY_PLACEHOLDER,
      })
    )
    .when(
      postponeJobData?.postponeReason,
      i18n.t('entity.postponedJobs.label.postponeReason', {
        note: postponeJobData?.postponeReason,
      })
    )
    .when(postponeJobData?.postponedBy && userQuery.data, () =>
      i18n.t('entity.postponedJobs.label.postponedBy', {
        name: getUserName(userQuery.data),
      })
    );
}
